import { IState } from "../..";
import { createSlice } from "@reduxjs/toolkit";
import { AppThunk } from "../../../app/store";
import ShipmentReconciliationService from "../../../app/data/shipment-reconciliation/shipmentReconciliationService";
import { OperationsAccessorialApprovalRequest } from "../../../app/data/shipment-reconciliation/models";
import { OperationsAccessorialApprovalState } from "../ShipmentReconciliationState";

const initialState: OperationsAccessorialApprovalState = {
  loading: false,
  loadingFailed: false,
  loaded: false
};

const shipmentReconciliationService = ShipmentReconciliationService.getInstance();

export const operationsAccessorialApprovalSlice = createSlice({
  name: "operationsAccessorialApprovalSlice",
  initialState,
  reducers: {
    resetOperationsAccessorialApprovalState: (state) => initialState,
    operationsAccessorialApprovalLoadingStarted: (state) => {
      state.loading = true;
      state.loadingFailed = false;
      state.loaded = false;
    },
    operationsAccessorialApprovalSucceed: (state, { payload }) => {
      state.loaded = true;
      state.loading = false;
      state.loadingFailed = false;
    },
    operationsAccessorialApprovalLoadingFailed: (state, { payload }) => {
      state.loading = false;
      state.loadingFailed = true;
    }
  },
});

export const {
  resetOperationsAccessorialApprovalState,
  operationsAccessorialApprovalLoadingStarted,
  operationsAccessorialApprovalSucceed,
  operationsAccessorialApprovalLoadingFailed
} = operationsAccessorialApprovalSlice.actions;

export const operationsAccessorialApprovalSelector = (state: IState) => state.operationsAccessorialApproval;

export const submitOperationsAccessorialApproval = (
  shipmentWorkItemId: number,
  accessorialId: string,
  requestData: OperationsAccessorialApprovalRequest,
  onSuccess?: () => void,
  onError?: (error: string) => void
): AppThunk => async (dispatch) => {
  dispatch(operationsAccessorialApprovalLoadingStarted());
  const response = await shipmentReconciliationService.submitOperationsAccessorialApproval(
    shipmentWorkItemId,
    accessorialId,
    requestData
  );
  if (response.ok() && response.data) {
    dispatch(operationsAccessorialApprovalSucceed(response.data));
    onSuccess && onSuccess();
  } else {
    let error = "Internal Server Error, re-try the action or contact support";
    if (response && response.data && response.data.message) error = JSON.stringify(response.data.message);
    dispatch(operationsAccessorialApprovalLoadingFailed(error));
    onError && onError(error)
  }
};

const operationsAccessorialApprovalReducer = operationsAccessorialApprovalSlice.reducer;
export default operationsAccessorialApprovalReducer;